<template>
  <div class="b-tabs-wrap d-xl-flex">
    <VTabs
      class="b-tabs"
      v-model="tab"
      background-color="transparent"
      color="dark"
      slider-size="2"
      slider-color="primary"
      :vertical="$vuetify.breakpoint.xlOnly"
      hide-slider
    >
      <VTab class="tab-name mr-4 mr-lg-6">
        {{ $t("settingsTemplates") }}
      </VTab>
      <VTab class="tab-name mr-4 mr-lg-6">
        {{ $t("editor") }}
      </VTab>
    </VTabs>
    <VTabsItems v-model="tab" class="flex-grow-1" touchless>
      <VTabItem class="account-card">
        <NotificationTemplatesList :company="company" />
      </VTabItem>
      <VTabItem class="account-card">
        <AppWithLoading :fetch="fetchMailTemplate" v-slot:default="{ localLoading }">
          <MailTemplateEditorTab v-if="!localLoading" :company="company" />
        </AppWithLoading>
      </VTabItem>
    </VTabsItems>
  </div>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api';
import { notificationTemplatesTabs, settingsTabs } from '@/enums';
import useMailTemplateEditor from '@/compositions/useMailTemplateEditor';
import NotificationTemplatesList from './NotificationTemplatesList.vue';
import MailTemplateEditorTab from './MailTemplateEditorTab.vue';
import AppWithLoading from '../AppWithLoading.vue';

export default {
  name: 'NotificationTemplates',
  components: {
    AppWithLoading,
    NotificationTemplatesList,
    MailTemplateEditorTab,
  },
  props: {
    type: {
      type: String,
      default: notificationTemplatesTabs.TEMPLATES,
    },
    company: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const { type } = toRefs(props);
    const { fetchMailTemplate } = useMailTemplateEditor();
    const tabList = [notificationTemplatesTabs.MAIL_TEMPLATES, notificationTemplatesTabs.EDITOR];

    const tab = computed({
      get: () => {
        const index = tabList.indexOf(type.value);
        return index === -1 ? 0 : index;
      },
      set: (index) => {
        const newType = tabList[index];
        if (newType !== type.value) {
          root.$router.replace({
            name: 'settings',
            params: {
              type: settingsTabs.TEMPLATES,
              addType: newType,
            },
          });
        }
      },
    });

    return {
      tab,
      fetchMailTemplate,
    };
  },
};
</script>

<style lang="scss" scoped>
.tab-name {
  font-size: 1rem;
  letter-spacing: 0;
  line-height: 1.25;
}
@media #{map-get($display-breakpoints, 'xl-only')} {
  .b-tabs-wrap {
    padding-top: 2.5rem;
  }
  .b-tabs {
    min-width: 15rem;
    max-width: 15rem;
    margin-right: 1.25rem;
  }
  .tab-name {
    justify-content: left;
    border-bottom: 1px solid rgba(196, 196, 196, 0.5);
  }
}

::v-deep .v-tab--active {
  color: #0A82D9;
}
</style>

<i18n locale="en" lang="yaml">
  settingsTemplates: Template Settings
  editor: The Email Editor
</i18n>

<i18n locale="ru" lang="yaml">
  settingsTemplates: Настройки шаблонов
  editor: Редактор письма
</i18n>
